<template>
  <div class="flex flex-column justify-between  full-height">
    <div class="col-12">
      <div class="col-12 p0 py2 my1 break-word">
        <h2 class="m0 caps">
          Récapitulatif de commande
        </h2>
      </div>
      <div v-if="itemsInWorkspace.length">
        <CartCard :is-cart-recap="true" :discount-price="promoPrice" :pro-rata="proRata" />
        <div v-if="hasInstallments" class="col-12 flex no-box px1 py2 items-center white-bg mt2">
          <div class="mr1">
            <input id="parceled" v-model="parceled" type="checkbox" class="pointer" value="true">
          </div>
          <label for="parceled" class="pointer">Paiement en 4 fois</label>
        </div>

        <div class="my2">
          <Parcel :parceled="parceled" />
        </div>
        <CartRecapPromo v-if="isSGWorkspace && !applyPromo && !hasPromo && !gymlibSale && !loading" />
        <!-- discount isImpersonateMode && isSGWorkspace-->
        <ImpersonatePromo
          v-if="isImpersonateMode && isSGWorkspace"
          class="mt2"
          :total-price-cart="totalPriceWithProRata"
          @discountAmount="changeAmount"
          @discountAmountFee="changeAmountFee"
          @discountMetric="selectMetric"
          @discountMotive="selectMotive"
          @applyPromo="setApplyPromo"
        />
        <!-- cgi-->
        <div v-if="!isImpersonateMode" class="col-12 flex no-box px1 py2 items-center flex-column white-bg mt2">
          <div class="flex col-12 px0 align-middle" @click="cgi = !cgi">
            <div class="mr1">
              <input id="cgi" v-model="cgi" type="checkbox" class="pointer">
            </div>
            <label class="h5 self-center">
              Je certifie avoir lu et accepté <a class="h4 pointer cgi" :href="cgiHref" target="_blank"><span class="h4 pointer cgi underline">les conditions générales de vente</span></a> et <a class="h4 pointer cgi" :href="regHref" target="_blank"><span class="h4 pointer cgi underline">le règlement intérieur.</span></a>
            </label>
          </div>
          <span v-if="canShowCgiError" class="h5 block col-12 alert no-box red lighter-grey-bg p1 cgiError">
            <i class="mt2 icon h5 mr2 ml1 red icon-stop"></i>Merci de bien vouloir lire et accepter les conditions générales de ventes et le règlement intérieur
          </span>
        </div>
        <div v-if="isImpersonateMode && siteProRataActive">
          <ProRata @applyProRata="changeProRata" />
        </div>
      </div>
      <div v-else class="col-12 full-height flex flex-column justify-around">
        <h2 class="h2 regular">Votre panier est vide</h2>
        <div class="col-12 flex justify-center">
          <a class="col-6 p2 red-bg center pointer" @click="backToAlpha()">
            <span class="white btn-cta-text bold">Retour à l'accueil</span>
          </a>
        </div>
      </div>
      <span v-if="customInstallment && applyPromo"> La réduction sera prise en compte lors du traitement dans ShareGroop. Son impact n’apparaît pas sur cette étape de récapitulatif. </span>
      <Installment :show-no-selected-error="canShowInstallmentsError" @selected-installments="setInstallmentOption" />
    </div>

    <div v-if="showValider" class="col-12 my3 bottom-0 left-0 right-0">
      <div v-if="isImpersonateMode">
        <div v-if="paymentMethods.length" class="flex justify-center items-center md-sm-xs-flex-column mb2">
          <!--
            <Button v-for="(item, index) in siteInfo.tda_settings.impersonate.payment_methods" v-if="!loading" :key="index" :text="item.title" class="m2 px2" :action="(() => handlePay(item.combination))" />
            -->
          <Button v-if="!loading" text="Enregistrer le paiement" :action="() => showCustomPayments = true" :disabled="priceHasError" />
          <Button v-if="!loading" :action="handlePay" class="ml2 md-sm-xs-ml0 md-sm-xs-mt2" text="Envoyer le lien de Paiement" :disabled="priceHasError" />
          <CartRecapCustomPayments
            v-if="showCustomPayments"
            :total-price="totalPrice.toFixed(2)"
            :discount-price="promoPrice"
            @hide-popup="showCustomPayments = false"
            @handle-pay="handlePay"
          />
        </div>
        <div v-else>
          <Button v-if="!loading" :action="handlePay" text="Envoyer le lien de Paiement" :disabled="priceHasError" />
        </div>
      </div>
      <div v-else>
        <Button v-if="!loading" id="button-confirm-pay" :action="handlePay" :text="gymlibSale ? 'Finaliser ma réservation' : 'Valider et regler'" />
      </div>
    </div>
  </div>
</template>

<script>
import CartCard from '@/components/cart/CartCard.vue';
import CartRecapPromo from '@/components/cart/CartRecapPromo.vue';
import Parcel from '@/components/cart/Parcel.vue';
import Button from '@/components/elements/Button.vue';
import ProRata from '@/components/configure/ProRata.vue';
import CartRecapCustomPayments from '@/components/cart/CartRecapCustomPayments.vue';
import ImpersonatePromo from '@/components/promos/ImpersonatePromo.vue';
import Installment from '@/components/cart/Installment.vue';
import { generatePaymentSession } from '@/utils/requests';
import { computeTotalPrice } from '@/utils/labels';
import { backToAlpha } from '@/utils/utils';
import { hasInstallments } from '@/utils/logics';

export default {
  name: 'CartRecap',
  components: {
    Button,
    CartCard,
    Parcel,
    CartRecapCustomPayments,
    ProRata,
    CartRecapPromo,
    ImpersonatePromo,
    Installment
  },
  data () {
    return {
      cart: this.$store.state.cart,
      offerInfo: this.$store.state.offerInfo,
      product: this.$store.state.product,
      siteInfo: this.$store.state.siteInfo,
      parceled: false,
      loading: false,
      canShowCgiError: false,
      cgi: false,
      workspace: this.$store.getters.workspace,
      applyPromo: false,
      showCustomPayments: false,
      promoAmount: null,
      promoAmountFee: null,
      promoMotive: null,
      selectedMetric: null,
      discountMetrics: [
        { label: 'euro (€)', value: 'euro' },
        { label: 'pourcentage (%)', value: 'percentage' }
      ],
      proRata: !!this.$store.state.siteInfo?.pro_rata && !!this.$store.state.offerInfo?.sessionProRataAmount,
      customInstallment: false,
      selectedInstallmentsPayment: null,
      canShowInstallmentsError: false
    };
  },
  computed: {
    isSGWorkspace () {
      return this.$store.state.siteInfo.payments_platform === 'sharegroop';
    },
    gymlibSale () {
      const cart = this.cart.items.find(item => item.workspace === this.workspace);

      return cart.details.some(item => item.gymlibCode);
    },
    promoCampaign () {
      return this.$store.state.promoCampaign;
    },
    priceHasError () {
      if (this.promoAmount && this.selectedMetric) {
        const discount = parseFloat(this.promoAmount);
        switch (this.selectedMetric) {
          case 'euro': {
            const price = parseFloat(this.totalPriceWithProRata);
            return discount < 0 || discount > price;
          }
          case 'percentage': {
            return discount < 0 || discount > 100;
          }
          default:
            return false;
        }
      }
      return false;
    },
    priceInfo () {
      return this.cart.items.find(item => item.workspace === this.workspace).priceInfo;
    },
    totalPriceCart () {
      return this.priceInfo ? this.priceInfo.totalPrice : null;
    },
    totalPriceWithProRata () {
      const price = this.itemsInWorkspace[0].details.reduce((acc, item) => {
        acc += this.proRata ? item.proRataPrice || item.price : item.price;
        const totalOptions = item.options.reduce((acc2, item2) => {
          acc2 += item2.price;
          return acc2;
        }, 0);
        return acc + totalOptions;
      }, 0);
      return (price / 100).toFixed(2);
    },
    promoPrice () {
      const price = parseFloat(this.totalPriceWithProRata);
      const metric = this.selectedMetric || (this.promoCampaign ? 'percentage' : null);
      const amount = parseFloat(this.promoAmount || (this.promoCampaign ? this.promoCampaign.discount : null));
      const amountFee = parseFloat(this.promoAmountFee || 0);

      if (amount && metric) {
        if (this.priceHasError) {
          return price;
        }
        switch (metric) {
          case 'euro': {
            return parseFloat((price - parseFloat(amount) - parseFloat(amountFee)).toFixed(2));
          }
          case 'percentage': {
            return parseFloat(((1 - (parseFloat(amount) / 100)) * price).toFixed(2));
          }
          default:
            return price;
        }
      }
      return price;
    },
    paymentMethods () {
      return this.siteInfo?.tda_settings?.impersonate?.payment_methods || [];
    },
    isImpersonateMode () {
      return this.$store.getters.isImpersonateMode;
    },
    hasInstallments () {
      return hasInstallments(this.itemsInWorkspace[0].details[0], this.totalPrice);
    },
    workspaceCart () {
      return (this.cart.items || []).find(item => item.workspace === this.workspace);
    },
    cartInstallments () {
      return this.workspaceCart?.details[0]?.installments;
    },
    showValider () {
      const cart = (this.cart.items || []).find(item => item.workspace === this.workspace);

      return cart && Object.keys(cart).length !== 0;
    },
    productUrl () {
      return `${this.$store.getters.alphaURL}${this.$store.state.product.url}`;
    },
    cgiHref () {
      return `${this.$store.getters.siteURL}/cgi`;
    },
    regHref () {
      return `${this.$store.getters.siteURL}/reglement-interieur`;
    },
    isRecurring () {
      if (this.offerInfo) {
        return this.offerInfo.detail.recurring;
      }
      if (this.workspaceCart) {
        return this.workspaceCart.details[0].recurring;
      }
      return false;
    },
    itemsInWorkspace () {
      if (this.cart && this.cart.items) {
        return this.cart.items.filter(i => i.workspace === this.workspace);
      }
      return [];
    },
    hasPromo () {
      return this.itemsInWorkspace.some(item => item.details.some(participant => participant.promo));
    },
    totalPrice () {
      return this.computeTotalPrice(this.itemsInWorkspace);
    },
    siteProRataActive () {
      return !!this.$store.state.siteInfo?.pro_rata && !!this.offerInfo?.sessionProRataAmount;
    }
  },
  watch: {
    cgi: function (newVal, _oldVal) {
      if (newVal) {
        this.canShowCgiError = false;
      }
    }
  },
  methods: {
    computeTotalPrice,
    backToAlpha,
    isSelected (value) {
      return this.selectedMetric === value;
    },
    selectMetric (value) {
      this.selectedMetric = value;
    },
    selectMotive (value) {
      this.promoMotive = value;
    },
    changeAmount (value) {
      this.promoAmount = value;
    },
    changeAmountFee (value) {
      this.promoAmountFee = value;
    },
    changeProRata (value) {
      this.proRata = value;
    },
    async handlePay (customPayments, cgi = false) {
      if (!this.isImpersonateMode && !this.cgi && !cgi) {
        this.canShowCgiError = true;
        return;
      }
      if (this.cartInstallments && !this.selectedInstallmentsPayment) {
        this.canShowInstallmentsError = true;
        return;
      }
      this.$store.commit('setLoading', true);
      window.dataLayer.push({
        checkoutStepName: 'prêt à payer',
        checkoutStepNumber: 8,
        event: 'ecommerceNEO',
        eventCommand: 'checkoutStep'
      });

      const args = {
        user: this.$store.state.user.uuid,
        workspace: this.$store.getters.workspace,
        parceled: this.parceled,
        customPayments: customPayments,
        promoAmount: this.promoAmount,
        promoMetric: this.selectedMetric,
        promoCode: this.promoCampaign ? this.promoCampaign.code : null,
        promoMotive: this.promoMotive,
        proRata: this.proRata,
        forceInstallments: this.customInstallment
      };

      await generatePaymentSession(args);
    },
    setApplyPromo (value) {
      this.applyPromo = value;
    },
    setInstallmentOption (value) {
      this.selectedInstallmentsPayment = value;
      this.customInstallment = value === 'installment';
      this.canShowInstallmentsError = false;
    }
  }
};
</script>

<style lang="scss" scoped>
  .cgi{
    font-size: 16px;
    color: inherit;
  }

  .cgiError{
    font-size: 14px;
  }
</style>
